import { render, staticRenderFns } from "./UserEkspedisiDrop.vue?vue&type=template&id=33a83c8a&scoped=true"
import script from "./UserEkspedisiDrop.vue?vue&type=script&lang=js"
export * from "./UserEkspedisiDrop.vue?vue&type=script&lang=js"
import style0 from "./UserEkspedisiDrop.vue?vue&type=style&index=0&id=33a83c8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a83c8a",
  null
  
)

export default component.exports